import MoldData from "@/classes/MoldData";

export async function ImportMoldData(sheet)
{
    const result = [];

    const START_ROW = 3;
    const COL_FILTER = 1;
    const COL_IMPORT_DATE = 2;
    const COL_PAY_DATE = 3;
    const COL_FACTORY = 4;
    const COL_NAME = 5;
    const COL_PRICE = 6;
    const COL_CONVERSION = 15;

    const LAST_ROW = sheet.lastRow.number;

    for (let i = START_ROW; i <= LAST_ROW; i++)
    {
        const row = sheet.getRow(i);
        const newMold = new MoldData();

        newMold.FilterLetter = row.getCell(COL_FILTER).value;
        newMold.Name = row.getCell(COL_NAME).value;
        newMold.Price = GetMoldCellFloat(row.getCell(COL_PRICE));

        // Import date will be in a not valid date format like 2025/1月
        newMold.ImportDate = row.getCell(COL_IMPORT_DATE).value;

        const match = (newMold.ImportDate + '').match(/^(\d{4})\/(\d+)月$/);
        if (match)
        {
            const year = parseInt(match[1], 10);
            const month = parseInt(match[2], 10) - 1;
            newMold.ImportDate = new Date(year, month, 1);
            newMold.ImportDate.setHours(newMold.ImportDate.getHours() + 9);
            newMold.ImportDate = newMold.ImportDate.toISOString();

            if (newMold.Price === 3000)
            {
                console.log(`import date (${year}/${month})`, newMold.ImportDate);
            }
    
        }

        newMold.PaymentDate = row.getCell(COL_PAY_DATE).value;

        if (!match && typeof newMold.PaymentDate === typeof new Date())
        {
            newMold.ImportDate = newMold.PaymentDate;
        }

        newMold.Factory = row.getCell(COL_FACTORY).value;
        

        
        newMold.YenConversion = GetMoldCellFloat(row.getCell(COL_CONVERSION));

        result.push(newMold);
    }

    return result;
}

function GetMoldCellFloat(cell)
{
    if (cell.value === null || cell.value === undefined)
    {
        return null;
    }
        
    return cell.formula ? cell.result : parseFloat(cell.value);
}